/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPersonaStatuses_creditApplications_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson = { readonly __typename: 'SignedCreditApplicationPerson', readonly firstName: string, readonly lastName: string };

export type GetPersonaStatuses_creditApplications_CreditApplication_personaInquiries_PersonaInquiry = { readonly __typename: 'PersonaInquiry', readonly status: _Types.PersonaInquiryStatus, readonly inquiryId: string, readonly person: GetPersonaStatuses_creditApplications_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson };

export type GetPersonaStatuses_creditApplications_CreditApplication = { readonly __typename: 'CreditApplication', readonly personaInquiries: ReadonlyArray<GetPersonaStatuses_creditApplications_CreditApplication_personaInquiries_PersonaInquiry> };

export type GetPersonaStatuses_Query = { readonly __typename: 'Query', readonly creditApplications: ReadonlyArray<GetPersonaStatuses_creditApplications_CreditApplication> | null };


export type GetPersonaStatusesVariables = _Types.Exact<{ [key: string]: never; }>;


export type GetPersonaStatuses = GetPersonaStatuses_Query;


export const GetPersonaStatusesDocument = gql`
    query GetPersonaStatuses {
  creditApplications {
    personaInquiries {
      status
      inquiryId
      person {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetPersonaStatuses__
 *
 * To run a query within a React component, call `useGetPersonaStatuses` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonaStatuses` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonaStatuses({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonaStatuses(baseOptions?: Apollo.QueryHookOptions<GetPersonaStatuses, GetPersonaStatusesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonaStatuses, GetPersonaStatusesVariables>(GetPersonaStatusesDocument, options);
      }
export function useGetPersonaStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonaStatuses, GetPersonaStatusesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonaStatuses, GetPersonaStatusesVariables>(GetPersonaStatusesDocument, options);
        }
export function useGetPersonaStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonaStatuses, GetPersonaStatusesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonaStatuses, GetPersonaStatusesVariables>(GetPersonaStatusesDocument, options);
        }
export type GetPersonaStatusesHookResult = ReturnType<typeof useGetPersonaStatuses>;
export type GetPersonaStatusesLazyQueryHookResult = ReturnType<typeof useGetPersonaStatusesLazyQuery>;
export type GetPersonaStatusesSuspenseQueryHookResult = ReturnType<typeof useGetPersonaStatusesSuspenseQuery>;
export type GetPersonaStatusesQueryResult = Apollo.QueryResult<GetPersonaStatuses, GetPersonaStatusesVariables>;